import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

type EditBusinessTripState = {
  data: any
  isOpenSettings: boolean
  isOpenSummary: boolean
  showGpsView: boolean
  showTmsView: boolean
  showTachographView: boolean
  showBordersView: boolean
  showCardLoadsView: boolean
  refreshKey: number
}

type EditBusinessTripActions = {
  setData: (data: any) => void
  setIsOpenSettings: (open: boolean) => void
  setIsOpenSummary: (open: boolean) => void
  setShowGpsView: (show: boolean) => void
  setShowTmsView: (show: boolean) => void
  setShowTachographView: (show: boolean) => void
  setShowBordersView: (show: boolean) => void
  setShowCardLoadsView: (show: boolean) => void
  setExtraViewFalse: () => void
  refresh: () => void
  reset: () => void
}

const initial: EditBusinessTripState = {
  data: null,
  isOpenSettings: false,
  isOpenSummary: false,
  showGpsView: false,
  showTmsView: false,
  showTachographView: false,
  showBordersView: false,
  showCardLoadsView: false,
  refreshKey: 0,
}

export const selectIsAnyExtraContentOpen = (s: EditBusinessTripState) =>
  s.showGpsView || s.showTmsView || s.showTachographView || s.showBordersView || s.showCardLoadsView

export const useEditBusinessTripStore = create<EditBusinessTripState & EditBusinessTripActions>()(
  devtools(
    zustandPlugin(
      (set) => ({
        ...initial,
        setData: (data) => set({ data }, false, 'setData'),
        setIsOpenSettings: (isOpenSettings) => set({ isOpenSettings }, false, 'setIsOpenSettings'),
        setIsOpenSummary: (isOpenSummary) => set({ isOpenSummary }, false, 'setIsOpenSummary'),
        setShowGpsView: (showGpsView) => set({ showGpsView }, false, 'setShowGpsView'),
        setShowTmsView: (showTmsView) => set({ showTmsView }, false, 'setShowTmsView'),
        setShowTachographView: (showTachographView) => set({ showTachographView }, false, 'setShowTachographView'),
        setShowBordersView: (showBordersView) => set({ showBordersView }, false, 'setShowBordersView'),
        setShowCardLoadsView: (showCardLoadsView) => set({ showCardLoadsView }, false, 'setShowCardLoadsView'),
        setExtraViewFalse: () => set({
          showGpsView: false,
          showTmsView: false,
          showTachographView: false,
          showBordersView: false,
          showCardLoadsView: false,
        }, false, 'setExtraViewFalse'),
        refresh: () => set((s) => ({ refreshKey: s.refreshKey + 1 }), false, 'refresh'),
        reset: () => set(initial, false, 'reset'),
      }),
      'edit-business-trip',
    ),
    { name: 'EasyTacho', store: 'edit-business-trip' },
  ),
)
